import useUser from '@authentication/hooks/useUser';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { FullStack } from './public-route.styled';
import { Navigate, useNavigate } from 'react-router-dom';
import Paths from '@/routes/paths';

interface Props {
  children: React.ReactNode;
}

const PublicRoute: React.FC<Props> = ({ children }) => {
  const { user, isLoading } = useUser();
  const navigation = useNavigate();

  React.useEffect(() => {
    if (location.pathname !== '/') {
      if (!user) {
        navigation('/login');
      } else {
        navigation('/');
      }
    }
  }, []);

  if (isLoading)
    return (
      <FullStack alignItems={'center'} justifyContent={'center'}>
        <CircularProgress />
      </FullStack>
    );
  return !user ? <h1>{children}</h1> : <Navigate to={Paths.LoginPage} />;
};

export default PublicRoute;
